export enum LanguageType {
    English = 'en',
    Japan = 'ja',
    SouthKorea = 'ko',
}
